import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ViewSelectSnapshot } from '@ngxs-labs/select-snapshot';
import { Store } from '@ngxs/store';
import {
  ConnectionsSelectors,
  CreateBotConnection,
  RemoveBotConnection,
  UpdateBotConnection,
} from 'projects/brn-frontend/src/app/core/store/bot-connections';

@Component({
  selector: 'brn-viber-connection-modal',
  templateUrl: './viber-connection-modal.component.html',
  styleUrls: ['./viber-connection-modal.component.scss'],
})
export class ViberConnectionModalComponent implements OnInit {
  @ViewSelectSnapshot(ConnectionsSelectors.pendingStatus)
  pendingStatus!: boolean;

  newConnection = true;

  viberForm = this.formBuilder.group({
    app_id: ['', Validators.required],
    app_key: ['', Validators.required],
  });

  constructor(
    private store: Store,
    private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<ViberConnectionModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (data.providerData) {
      this.newConnection = false;
      this.viberForm.patchValue(data.providerData);
    }
  }

  ngOnInit(): void {}

  get validForm(): boolean {
    return this.viberForm.valid;
  }

  createConnection(): void {
    if (!this.validForm || this.pendingStatus) {
      return;
    }
    const providerData = this.viberForm.value;
    this.store.dispatch(new CreateBotConnection('viber', providerData));
  }

  updateConnection(): void {
    if (!this.validForm || this.pendingStatus) {
      return;
    }
    const providerData = this.viberForm.value;
    this.store.dispatch(new UpdateBotConnection('viber', providerData));
  }

  removeConnection(): void {
    if (this.pendingStatus) {
      return;
    }
    this.store.dispatch(new RemoveBotConnection('viber'));
  }

  closeModal(): void {
    this.dialogRef.close();
  }
}
